import script from "./AppHeaderFaqAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderFaqAnswer.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderFaqAnswer.vue?vue&type=style&index=0&id=d3559de4&lang=scss"

const __exports__ = script;

export default __exports__